/*!
* Product Page: https://www.creative-tim.com/product/material-dashboard-react
*/
import React from 'react'
// import axios from 'axios';
// nodejs library to set properties for components
import PropTypes from 'prop-types'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// core components
import GridItem from 'components/Grid/GridItem.jsx'
import GridContainer from 'components/Grid/GridContainer.jsx'
import Card from 'components/Card/Card.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import Button from 'components/CustomButtons/Button.jsx'
import Dropdown from 'views/ProductRanking/Dropdown.jsx'
// import needed variables
import mappedRetailers from 'config/retailers.js'
import { categories } from 'variables/categories.jsx'

import api from 'api/api.js'

const styles = {
  cardCategoryWhite: {
    '&,& a,& a:hover,& a:focus': {
      color: 'rgba(255,255,255,.62)',
      margin: '0',
      fontSize: '14px',
      marginTop: '0',
      marginBottom: '0'
    },
    '& a,& a:hover,& a:focus': {
      color: '#FFFFFF'
    }
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', sans-serif',
    marginBottom: '3px',
    textDecoration: 'none',
    '& small': {
      color: '#777',
      fontSize: '65%',
      fontWeight: '400',
      lineHeight: '1'
    }
  }
}

class BackendControl extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sortBy: { val: 'Sort by', _id: null },
      category: { val: 'Product Category', _id: null },
      retailer: { val: 'Retailer', _id: null },
      allRetailers: [],
      allCategories: [],
      sortByOptions: [{ full_name: 'Margin', _id: 0 }, { full_name: 'Sales', _id: 1 }, { full_name: 'Newness', _id: 2 }, { full_name: 'Customer Affinity', _id: 3 }, { full_name: 'Trends', _id: 4 }, { full_name: 'Stock on Hand', _id: 5 }],
      submitSuccess: false,
    }
  }

    handleDropdownChange = (font, name, id) => {
      let dropdownSelect = this.state[name]
      dropdownSelect.val = font
      dropdownSelect._id = id
      this.setState({ [name]: dropdownSelect })
    }

    submitProductRanking = () => {
      if (!Number.isInteger(this.state.category._id) || !Number.isInteger(this.state.sortBy._id || !Number.isInteger(this.state.retailer._id))) {
        console.log('not valid')
        return
      }

      this.setState({ submitSuccess: true })

      setTimeout(() => {
        this.setState({ submitSuccess: false })
      }, 2000)

      let body = {
        sortByOption: this.state.sortBy.val,
        category_ids_restriction: this.state.category._id,
        retailer_restriction: this.state.retailer.val
      }
      api
        .submitValuesForProductRanking(body)
        .then(results => {
          if (results.data.error) {
            return
          }
        })
        .catch(err => {
          this.setState({
            error: 'Something went wrong',
          })
        })
    }

    async getGarmentCategories() {
      this.setState({
        allCategories: categories,
      })
    }

    async getRetailers() {
      let retailers = Object.keys(mappedRetailers).map((mappedRetailer, indx) => {
        return { _id: indx, full_name: mappedRetailer }
      })
      this.setState({ allRetailers: retailers })
    }

    async componentDidMount() {
      await this.getGarmentCategories()
      await this.getRetailers()
    }

    render() {
      const { classes } = this.props
      return (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>Instructions</h4>
                <p className={classes.cardCategoryWhite}>
                                Choose a retailer, a category and a sort by option to change the default ranking of the garments
                </p>
              </CardHeader>
              <CardBody style={{ height: '-webkit-fill-available' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Dropdown
                    name={'retailer'}
                    value={this.state.retailer}
                    handleDropdownChange={this.handleDropdownChange}
                    options={this.state.allRetailers} />
                  <Dropdown
                    name={'category'}
                    value={this.state.category}
                    handleDropdownChange={this.handleDropdownChange}
                    options={this.state.allCategories} />
                  <Dropdown
                    name={'sortBy'}
                    value={this.state.sortBy}
                    handleDropdownChange={this.handleDropdownChange}
                    options={this.state.sortByOptions} />
                  {this.state.submitSuccess ? <Button type="button" color="success" onClick={this.submitProductRanking} disabled>Submit</Button> : <Button type="button" color="primary" onClick={this.submitProductRanking}>Submit</Button>
                  }
                </div>

              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      )
    }
}

BackendControl.propTypes = {
  classes: PropTypes.object
}

export default withStyles(styles)(BackendControl)
